import { render, staticRenderFns } from "./modal_data_anamnese.vue?vue&type=template&id=9f2c2f1a&scoped=true"
import script from "./modal_data_anamnese.vue?vue&type=script&lang=js"
export * from "./modal_data_anamnese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2c2f1a",
  null
  
)

export default component.exports